import { isFullSubmission } from '../../../utils/slimSubmissions';

/**
 * SHER-1162 — which stored submission the edit form may be seeded from.
 *
 * The form under FillDataCollection seeds its values once, at mount. Opening a patient
 * loads slim rows (no answers), so seeding from one opens an empty edit form, and saving
 * it blanks the record. Only a full submission is editable; null means "not loaded yet"
 * and the page shows the Loader until the full load the update view triggers lands.
 */
export function submissionToEdit<T extends { id?: unknown; __slim?: boolean }>(
    submissions: T[] | null | undefined,
    idSubmission: unknown,
): T | null {
    return (submissions ?? []).find((sub) => isFullSubmission(sub) && sub.id === idSubmission) ?? null;
}
